import React, { useEffect } from "react";
import { motion } from "framer-motion";
import { ArrowRight, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Footer } from "@/components/landing/Sections";
import { COURSE_ACCESS_URL } from "@/config";

export default function ThankYou() {
  useEffect(() => {
    document.title = "Thank You — Your Course Access | Hypnosis, The Course";

    // Meta Pixel: this is the real post-purchase confirmation page, so this
    // is the right place to fire the Purchase conversion event.
    if (typeof window !== "undefined" && window.fbq) {
      window.fbq("track", "Purchase", { currency: "INR", value: 3500 });
    }
  }, []);

  return (
    <div className="min-h-screen bg-black text-white overflow-x-hidden">
      <section className="relative min-h-[85vh] flex items-center overflow-hidden">
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-gradient-to-b from-[#1a1005] via-black to-black" />
          <div className="absolute inset-0 candle-glow flicker" />
        </div>

        <div className="relative max-w-3xl mx-auto px-6 lg:px-8 py-28 text-center z-10">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.9, ease: "easeOut" }}
          >
            <div className="flex items-center justify-center gap-3 mb-8">
              <img
                src="/images/logo.png"
                alt="Hypno Guru"
                className="w-8 h-8 rounded-full object-cover border border-[#F89C03]/40"
              />
              <span className="text-xs tracking-[0.45em] uppercase text-[#F89C03] font-medium">
                Payment Confirmed
              </span>
            </div>

            <h1 className="font-serif-display text-5xl sm:text-6xl leading-[1.05] text-white mb-6">
              Congratulations.
            </h1>

            <p className="text-lg sm:text-xl text-[#CFCFCF] leading-relaxed font-light mb-2">
              Welcome to Hypnosis — The Course.
            </p>
            <p className="text-sm text-[#F89C03]/90 font-light mb-4">
              Please wait 2–3 minutes before logging in to the course for smooth access.
            </p>
            <p className="text-base text-[#9B9B9B] leading-relaxed font-light max-w-xl mx-auto mb-12">
              Your enrollment is confirmed. Everything you need to get
              started — login details and access instructions — has also
              been sent to your WhatsApp and email.
            </p>

            <Button
              data-testid="cta-thank-you"
              onClick={() =>
                window.open(COURSE_ACCESS_URL, "_blank", "noopener,noreferrer")
              }
              className="h-14 px-8 bg-[#F89C03] hover:bg-[#FFB933] text-black font-semibold tracking-wide rounded-full text-base glow-pulse cta-shine"
            >
              Click here to access the course
              <ArrowRight className="ml-2 w-4 h-4" />
            </Button>

            <div className="mt-8 flex items-center justify-center gap-2 text-sm text-[#B5B5B5]">
              <ShieldCheck className="w-4 h-4 text-[#F89C03]" />
              60-day money-back guarantee still applies
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
